var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding-error"},[_c('div',{staticClass:"onboarding-error-message"},[_c('Icon',{staticClass:"alert-icon",attrs:{"name":"error"}}),_c('h3',[_vm._v(_vm._s(_vm.errorText))])],1),_c('div',{staticClass:"onboarding-error-button"},[_c('Button',{on:{"click":_vm.handleClick}},[_c('span',[_vm._v("Tentar novamente")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }